// There's a circular ref involving a test file that needs to be resolved before this rule can be enabled:
// See https://ghe.coxautoinc.com/DigitalRetailing/dr-dash/issues/2615 for description of this issue.

// externals
import type { Reducer } from 'redux';

// libraries
import type { AccessoriesState } from '@makemydeal/dr-dash-types';
import { buildUniqueScrollRequestId } from '@makemydeal/dr-dash-ui-utils';

// consts/enums
import * as accessoriesActionTypes from '../actionTypes/accessoriesActionTypes';
import { INIT_ACCESSORIES, ADD_ACCESSORIES_SELECTIONS } from '../actionTypes/accessoriesActionTypes';
import { PAYMENT_FAILURE } from '../actionTypes/deskingActionTypes';

// interfaces/types
import type { AccessoriesOpenFormAction } from '../actions/accessoriesActionCreators';

// utils
import { AccessoriesAdapter } from '../utils/manualAccessoriesAdapter';

export type AccessoriesReducer = Reducer<AccessoriesState>;

export const initialState: AccessoriesState = {
    accessoryObjList: [],
    elements: [],
    isFormOpen: false,
    uniqueScrollRequestId: false,
    lastValidElements: [],
    hasCatalogAccessories: false,
    arePricesAdjusted: false
};

export const reducer: AccessoriesReducer = (state: AccessoriesState = initialState, action: any): AccessoriesState => {
    switch (action.type) {
        case INIT_ACCESSORIES: {
            const accessories = action.payload.accessories;
            if (accessories) {
                const mappedformattedAccessories = AccessoriesAdapter.accessoriesToSourceFormat(action.payload.accessories);
                return {
                    ...state,
                    ...mappedformattedAccessories
                } as AccessoriesState;
            } else {
                return state;
            }
        }
        case accessoriesActionTypes.ACCESSORIES_OPEN_FORM: {
            const actionTyped = action as AccessoriesOpenFormAction;
            return {
                ...state,
                isFormOpen: true,
                uniqueScrollRequestId: actionTyped.payload?.scrollIntoView ? buildUniqueScrollRequestId() : false
            };
        }
        case accessoriesActionTypes.FOCUS_ACCESSORIES_TABLE: {
            return {
                ...state,
                isFormOpen: false,
                uniqueScrollRequestId: buildUniqueScrollRequestId()
            };
        }

        case accessoriesActionTypes.ACCESSORIES_CLOSE_FORM: {
            return {
                ...state,
                isFormOpen: false,
                uniqueScrollRequestId: false
            };
        }
        case accessoriesActionTypes.ADD_ACCESSORIES_SELECTIONS: {
            return {
                ...state,
                accessoryObjList: action.payload.accessories
            };
        }
        case accessoriesActionTypes.ADDED_MANUAL_ACCESSORIES: {
            return {
                ...state,
                elements: action.payload.manualAccessories.accessories,
                lastValidElements: action.payload.manualAccessories.accessories
            };
        }
        case PAYMENT_FAILURE: {
            if (action.meta?.actionForPayment === ADD_ACCESSORIES_SELECTIONS) {
                return {
                    ...state,
                    elements: state.lastValidElements || []
                };
            } else {
                return state;
            }
        }
        case accessoriesActionTypes.CHECK_ACCESSORIES_CATALOG_EXISTS_REQUEST:
        case accessoriesActionTypes.CHECK_ACCESSORIES_CATALOG_EXISTS_FAILURE: {
            return {
                ...state,
                hasCatalogAccessories: false
            };
        }
        case accessoriesActionTypes.CHECK_ACCESSORIES_CATALOG_EXISTS_SUCCESS: {
            return {
                ...state,
                hasCatalogAccessories: Boolean(action.payload.data?.exists || action.payload.exists)
            };
        }

        default: {
            return state;
        }
    }
};
